import { environmentData } from "@/helper/environment";
import { SaveContainerService } from "@/service/import/save_container_service";
import { SaveContainerResponseInterface } from "@/interface/import/save_container_interface";

export class SaveContainerRepository {
  private readonly service: SaveContainerService;

  constructor(vesselConfigurationService: SaveContainerService) {
    this.service = vesselConfigurationService;
  }

  async saveContainers(payload: any): Promise<SaveContainerResponseInterface> {
    const url = `${environmentData.domain}/v1/watchlist`;
    const containers: SaveContainerResponseInterface = await this.service.saveContainers(url, payload);
    return containers;
  }
}
